import '../..//GooglePlay.css';
import { useEffect, useState } from 'react';

export default function RapidInstallCard({ progress, onCloseCard, onInstallNow }) {
  const [activated, setActivated] = useState(false);

  useEffect(() => {
    if (progress >= 100) {
      setTimeout(() => setActivated(true), 400);
    }
  }, [progress]);

  return (
    <div id="pop-show" style={{ display: 'block' }} onClick={onCloseCard}>
      <div className="mask"></div>
      
      {/* 关键点：去掉所有 Tailwind 宽度类（如 p-10, max-w-xs）。
          只保留 bd，它会从 GooglePlay.css 获取正确的 width 和 margin。
      */}
      <div className="bd" style={{ maxWidth: '350px', width: '85vw' }} onClick={e => e.stopPropagation()}>
        <strong id="wait-loading-strong">
          <img src="/image/lightning.svg" alt="" />
          Rapid Install
        </strong>

        {!activated ? (
          <div className="loading-ci" id="wait-loading-div">
            <div className="box"></div>
            <span id="count1">{Math.round(progress)}</span>%
          </div>
        ) : (
          <div className="show-btn" id="wait-div" style={{ display: 'block' }}>
            <div className="active-box">
              <span>
                <img src="/image/safe.svg" alt="" />
                Effective
              </span>
            </div>
            {/* 使用 btn big 类名以匹配 Landing.js 的按钮宽度 */}
            <button 
                className="btn big" 
                id="click-btn" 
                onClick={onInstallNow}
            >
              Install Now
            </button>
          </div>
        )}
      </div>
    </div>
  );
};